$component-class: 'dh-breadcrumbs-type-1';
$focus-ring-color: $dh-focus-ring-color;

.#{$component-class} {
  color: inherit;

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--spacing-2xs);
  }

  &__item {
    display: flex;
    align-items: center;
    gap: var(--spacing-2xs);
  }

  &__link,
  &__text {
    @include text-style('sm', 'md');

    color: inherit;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }

  &__link:hover {
    opacity: 0.7;
  }

  &__link:focus {
    outline: none;
  }

  &__link:focus-visible {
    outline: none;
    border-radius: var(--radius-size-sm);
    box-shadow:
      0 0 0 2px var(--color-neutral-white),
      0 0 0 4px #{$focus-ring-color};
  }

  &__item--current &__text {
    opacity: 0.65;
    font-weight: map-get($font-weights, 'normal');
  }

  &__separator {
    display: inline-flex;
    align-items: center;
    color: inherit;

    .dh-icon {
      @include size(16px);

      svg {
        fill: currentcolor;
      }
    }
  }
}
